import { GoogleOAuthProvider } from "@react-oauth/google";
import config from "@sg-protect/runtime-config";
import { type ReactNode, createContext, useCallback, useContext, useState } from "react";

interface GoogleContextType {
    token?: string;
    setToken: (token?: string) => void;
    isSignedIn: boolean;
}

const GoogleTokenKey = "googleIdToken";
const GoogleContext = createContext<GoogleContextType>({ setToken: () => {}, isSignedIn: false });

interface GoogleProviderProps {
    children: ReactNode;
}

export const GoogleProvider = ({ children }: GoogleProviderProps) => {
    const [token, setTokenState] = useState<string | undefined>(getGoogleToken());

    const setToken = useCallback((newToken?: string) => {
        if (newToken) {
            sessionStorage.setItem(GoogleTokenKey, newToken);
        } else {
            clearGoogleToken();
        }

        setTokenState(newToken);
    }, []);

    return (
        <GoogleContext.Provider
            value={{
                token,
                setToken,
                isSignedIn: !!token
            }}
        >
            <GoogleOAuthProvider clientId={config.get().google.app_id}>{children}</GoogleOAuthProvider>
        </GoogleContext.Provider>
    );
};

export const useGoogleContext = () => {
    return useContext(GoogleContext);
};

export function getGoogleToken(): string | undefined {
    return sessionStorage.getItem(GoogleTokenKey) ?? undefined;
}

export function clearGoogleToken() {
    return sessionStorage.removeItem(GoogleTokenKey);
}
